import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PageTitleService {
  constructor(private translateService: TranslateService,
              private titleService: Title) {}

  setTitle(titleKey: string, titleParam?: string) {
    const param = {
      value: titleParam
    };
    this.translateService.get(titleKey,  param).subscribe((translatedTitle) => {
      this.titleService.setTitle(translatedTitle);
    });
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/helpers/pageTitle.service.ts